const DEFAULT_API_BASE_ADMIN = (process.env.REACT_APP_API_BASE_ADMIN || "").trim().replace(/\/+$/, "");
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const SERVER_SELECTION_ENABLED = process.env.REACT_APP_ALLOW_SERVER_OVERRIDE === "1";

export const STORAGE_KEYS = {
    ACCESS_TOKEN: "WR_ADMIN_ACCESS_TOKEN",
    API_BASE_OVERRIDE: "WR_ADMIN_API_BASE_OVERRIDE",
    SERVER_SELECTION_SEEN: "WR_ADMIN_SERVER_SELECTION_SEEN",
    FCM_TOKEN_ANDROID: "WR_ADMIN_FCM_TOKEN_ANDROID",
    FCM_TOKEN_ANDROID_SENT: "WR_ADMIN_FCM_TOKEN_ANDROID_SENT",
    LAST_PUSH: "WR_ADMIN_LAST_PUSH",
};

function normalizeApiBase(value) {
    const normalized = (value || "").trim().replace(/\/+$/, "");
    if (!normalized) return "";

    let parsed;
    try {
        parsed = new URL(normalized);
    } catch (_) {
        throw new Error("Вкажіть повну адресу сервера у форматі https://domain.tld");
    }

    if (!["http:", "https:"].includes(parsed.protocol)) {
        throw new Error("Підтримуються лише http:// або https:// адреси сервера");
    }

    return parsed.toString().replace(/\/+$/, "");
}

function getStoredApiBaseOverride() {
    if (typeof window === "undefined") return "";
    try {
        return localStorage.getItem(STORAGE_KEYS.API_BASE_OVERRIDE) || "";
    } catch (_) {
        return "";
    }
}

function resolveApiBaseAdmin() {
    return normalizeApiBase(getStoredApiBaseOverride()) || DEFAULT_API_BASE_ADMIN;
}

export let API_BASE_ADMIN = resolveApiBaseAdmin();

export function isCapacitorRuntime() {
    try {
        return typeof window !== "undefined" && !!window.Capacitor;
    } catch (_) {
        return false;
    }
}

export function shouldAllowServerSelection() {
    return SERVER_SELECTION_ENABLED && isCapacitorRuntime();
}

export function getDefaultApiBaseAdmin() {
    return DEFAULT_API_BASE_ADMIN;
}

export function setApiBaseAdmin(value) {
    const normalized = normalizeApiBase(value);
    try {
        localStorage.setItem(STORAGE_KEYS.API_BASE_OVERRIDE, normalized);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_ADMIN = normalized;
    return API_BASE_ADMIN;
}

export function resetApiBaseAdmin() {
    try {
        localStorage.removeItem(STORAGE_KEYS.API_BASE_OVERRIDE);
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
    API_BASE_ADMIN = DEFAULT_API_BASE_ADMIN;
    return API_BASE_ADMIN;
}

export function hasSeenServerSelection() {
    try {
        return localStorage.getItem(STORAGE_KEYS.SERVER_SELECTION_SEEN) === "1";
    } catch (_) {
        return false;
    }
}

export function markServerSelectionSeen() {
    try {
        localStorage.setItem(STORAGE_KEYS.SERVER_SELECTION_SEEN, "1");
    } catch (_) {
        // ignore
    }
}

export function clearStoredAuthStateForServerChange() {
    try {
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    } catch (_) {
        // ignore
    }
}